module.exports = __webpack_public_path__ + "img/dumbbell.32b57fc2.svg";